let currentUtterance = null;

export const speak = (text) => {
  if (!text || typeof text !== "string") return;

  // Stop any existing speech
  window.speechSynthesis.cancel();

  const utterance = new SpeechSynthesisUtterance(text);

  const voices = window.speechSynthesis.getVoices();

  // Prefer natural English voices
  const preferred =
    voices.find(
      (v) =>
        v.lang.startsWith("en") &&
        /Google|Microsoft|Natural|Premium/i.test(v.name)
    ) || voices.find((v) => v.lang.startsWith("en"));

  if (preferred) {
    utterance.voice = preferred;
  }

  utterance.rate = 0.95;   // natural speed
  utterance.pitch = 1;
  utterance.volume = 1;

  currentUtterance = utterance;
  window.speechSynthesis.speak(utterance);
};

export const stopSpeaking = () => {
  window.speechSynthesis.cancel();
  currentUtterance = null;
};